module.exports = __webpack_public_path__ + "img/welcome_bg_new_xg.4032a8a2.jpg";